import React from 'react'
import { numK } from '../../lib/numbers'

export default function StatNumber({ statNum, statType, onClick }) {
  const isClickable = typeof onClick === 'function'

  return (
    <div className="text-center">
      <div className="display-3 numberValue">{numK(statNum)}</div>
      {isClickable ? (
        <div
          className="text-decoration-underline mt-1"
          style={{ cursor: 'pointer' }}
          onClick={onClick}
        >
          {statType}
        </div>
      ) : (
        <div>{statType}</div>
      )}
    </div>
  )
}
